module.exports = __webpack_public_path__ + "static/img/section_01_dynamic_engine_kv.0d21619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_01_dynamic_engine_kv.png
// module id = LYPj
// module chunks = 12